import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import CedulaDashboardContainer from './containers/CedulaDashboardContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnIndividualTransactionData = () => {
    const data = _.get(totalStats, 'item.total_individual_cedula_statuses');
    return {
      label: 'Individual',
      total: _.get(totalStats, 'item.total_individual_cedula', 0),
      // photo: ''
      list: [
        { label: 'For Pickup', value: _.get(data, 'FOR PICK-UP', 0), borderClassName: 'pickup' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Printed', value: _.get(data, 'PRINTED', 0), borderClassName: 'paid' },
        { label: 'Received', value: _.get(data, 'RECEIVED', 0), borderClassName: 'received' },
      ],
    }
  };
  const returnCorporationTransactionData = () => {
    const data = _.get(totalStats, 'item.total_corporation_cedula_statuses');
    return {
      label: 'Corporation',
      total: _.get(totalStats, 'item.total_corporation_cedula', 0),
      // photo: ''
      list: [
        { label: 'For Pickup', value: _.get(data, 'FOR PICK-UP', 0), borderClassName: 'pickup' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Printed', value: _.get(data, 'PRINTED', 0), borderClassName: 'paid' },
        { label: 'Received', value: _.get(data, 'RECEIVED', 0), borderClassName: 'received' },
      ],
    }
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnIndividualTransactionData()} className="mb-3" />
          <DashboardListCard data={returnCorporationTransactionData()} />
        </div>
        <div className="col-8 pr-0">
          <CedulaDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(TransactionsContainer);
